/**
 * /projects/new — full-page project create form.
 *
 * Mirrors `/projects/$projectId/tasks/new` (full-page TaskForm). On success
 * the underlying <ProjectForm> already routes to /projects/$projectId, so
 * this route only needs to render the form with a cancel handler that
 * returns to the projects list.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ProjectForm } from "@/components/ProjectForm";

function NewProjectPage() {
  const navigate = useNavigate();
  return (
    <div className="pg-wrap">
      <header className="pg-head">
        <h1>New project</h1>
      </header>
      <div className="panel">
        <div className="panel-body">
          <ProjectForm onCancel={() => void navigate({ to: "/projects" })} />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/projects/new")({
  component: NewProjectPage,
});
